import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App as AppNativa } from '@capacitor/app';
import { LocalNotifications } from '@capacitor/local-notifications';
import { usePerfil } from '../context/PerfilContext';
import { esApp } from '../utils/plataforma';
import { reprogramar } from '../utils/recordatoriosGastos';

/**
 * Mantiene al día los recordatorios para apuntar gastos (solo en la app).
 * Cada vez que la app se abre o vuelve a primer plano se reprograman, así el
 * aviso de inactividad se aplaza. Tocar uno lleva a las transacciones.
 */
export const RecordatoriosGastos: React.FC = () => {
  const navigate = useNavigate();
  const { perfil, cargandoPerfil, tieneModulo, esPlus } = usePerfil();
  const conFinanzas = tieneModulo('finanzas');

  useEffect(() => {
    if (!esApp || cargandoPerfil || !perfil) return;
    const aplicar = () => reprogramar(conFinanzas, esPlus).catch(e => console.warn('Recordatorios de gastos', e));
    aplicar();
    const vuelta = AppNativa.addListener('appStateChange', ({ isActive }) => { if (isActive) aplicar(); });
    return () => { vuelta.then(v => v.remove()); };
  }, [perfil, cargandoPerfil, conFinanzas, esPlus]);

  useEffect(() => {
    if (!esApp) return;
    const toque = LocalNotifications.addListener('localNotificationActionPerformed', ({ notification }) => {
      const ruta = notification.extra?.ruta;
      if (typeof ruta === 'string' && ruta.startsWith('/')) navigate(ruta);
    });
    return () => { toque.then(t => t.remove()); };
  }, [navigate]);

  return null;
};
